import detail from './detail'

const ApiCall = {
  detail
}

export default ApiCall
